import fascia from './fascia.jpg';
import printedBand from './screen-printed-band.jpg';

export default {
  'Printed Band': printedBand,
  'Fascia Trim': fascia,
};
